import { LegalList, LegalPage, LegalSection } from './LegalPage'

/** 문의를 받을 자리. 공개하기 전에 실제 값으로 채운다. */
const CONTACT = '운영자 연락처를 여기에 적는다'

export function TermsPage() {
  return (
    <LegalPage title="이용약관" effectiveDate="2026년 8월 28일">
      <LegalSection heading="이 약관이 무엇인가요">
        <p>
          mlog는 감정과 마음 상태, 일상의 일을 부담 없이 기록하는 개인용 공간이에요. 이 약관은
          mlog를 쓰는 사람과 운영자 사이의 약속을 적어 둔 것이고, 서비스를 쓰기 시작하면 이 내용에
          동의한 것으로 봅니다.
        </p>
      </LegalSection>

      <LegalSection heading="mlog는 의료 서비스가 아니에요">
        <p>
          mlog가 보여주는 감정 해석과 통계는 스스로를 돌아보는 데 쓰라고 만든 참고 자료예요.
          진단이나 치료, 상담을 대신하지 않고 의학적 판단의 근거로 쓸 수 없어요.
        </p>
        <p>
          지금 많이 힘들다면 혼자 견디지 말고 전문기관의 도움을 받으세요. 자살예방상담전화 109와
          정신건강상담전화 1577-0199는 하루 24시간 열려 있어요.
        </p>
      </LegalSection>

      <LegalSection heading="계정">
        <LegalList
          items={[
            '계정은 구글이나 네이버 로그인으로 만들어요. mlog는 비밀번호를 다루지 않아요.',
            '계정 하나는 한 사람의 것이에요. 다른 사람과 나눠 쓰거나 넘기지 말아 주세요.',
            '로그인한 곳의 계정을 잃으면 mlog에도 들어오지 못해요.',
            '언제든 계정을 지울 수 있어요. 지우면 기록도 함께 사라지고 되돌리지 못해요.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="기록은 쓴 사람의 것이에요">
        <p>
          mlog에 남긴 기록의 권리는 쓴 사람에게 있어요. 운영자는 서비스를 굴리는 데 필요한
          범위에서만 기록을 다루고, 그 밖의 목적으로 읽거나 쓰지 않아요.
        </p>
        <p>
          기록의 내용에 대한 책임은 쓴 사람에게 있어요. 법을 어기거나 다른 사람의 권리를 해치는 데
          mlog를 쓰지 말아 주세요.
        </p>
      </LegalSection>

      <LegalSection heading="하지 말아야 할 것">
        <LegalList
          items={[
            '다른 사람의 계정이나 기록에 닿으려고 시도하는 일',
            '서비스를 자동으로 긁어 가거나 과도한 요청으로 부담을 주는 일',
            '서비스의 취약점을 찾아 악용하는 일',
          ]}
        />
      </LegalSection>

      <LegalSection heading="서비스가 바뀌거나 멈출 수 있어요">
        <p>
          mlog는 아직 만들어 가는 중이에요. 기능이 바뀌거나 없어질 수 있고, 점검이나 장애로 잠시
          멈출 수도 있어요. 서비스를 아예 접게 되면 기록을 내려받을 수 있도록 미리 알릴게요.
        </p>
        <p>
          운영자는 고의나 중대한 과실이 없는 한 서비스 이용으로 생긴 손해를 책임지지 않아요. 다만
          기록을 지키는 일은 가장 중요하게 여기고 있어요.
        </p>
      </LegalSection>

      <LegalSection heading="약관이 바뀔 때">
        <p>
          내용을 고치면 시행일과 함께 이 화면에 올려요. 크게 달라지는 내용은 시행 전에 알릴게요.
          바뀐 약관에 동의하지 않으면 계정을 지우고 그만 쓸 수 있어요.
        </p>
      </LegalSection>

      <LegalSection heading="문의">
        <p>{CONTACT}</p>
      </LegalSection>
    </LegalPage>
  )
}
